<template>
  <RoamTransaction
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :formsConfig="formsConfig"
    :backButtonRoute="backButtonRoute"
    :screenJson="getScreenJson"
    :dataModel="dataModelToPass"
    :setLoading="setLoading"
    :saveDisabled="saveDisabled"
    :localDataGrid="true"
    :detailPopUpFormItems="getDetailPopupFormItems"
    :detailPopUpBack="detailPopUpBack"
    :validationSummary="validationSummary"
    :detailPopUpDataCallBack="detailPopUpDataCallBack"
    :barcodeScanned="barcodeScanned"
    :headerConfig="headerConfig"
    :selectedViewValue="0"
    :detailPopUpFormVisible="detailPopUpFormVisible"
    :detailPopUpFormDataModel="detailPopUpFormDataModel"
    :detailPopUpSaveCallBack="detailPopUpSaveCallBack"
    :getSelectedViewType="'details'"
    :detailPopUpConfig="detailPopUpConfig"
    :saveRoamTransaction="saveRoamTransaction"
    :saveRoamBtnConfig="{
      icon: undefined,
      text: 'Close',
    }"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RoamTransaction from "@/templates/roam/roam-transaction.vue";
import { RoamTransactionService } from "../../../_services/api/templates/roam-transactions.services";
import { RoamBinMovementsService } from "../../../_services/api/roam/bin/roam-bin-movement.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: { RoamTransaction },
  watch: {},
  async created() {
    this.resetLabels();
    this.setLoading = true;
    this.getBinLocation();
  },
  mounted() {},
  data() {
    return {
      allowOverPicking: false,
      backButtonRoute: "/roam-bin-movement",
      dataModel: undefined,
      validationSummary: [],
      setLoading: false,
      saveDisabled: {
        header: true,
        detail: true,
        line: false,
        save: false,
      },
      productsList: [],
      detailPopUpData: {
        EnableSave: false,
      },
      detailPopUpFormVisible: false,
      detailPopUpFormDataModel: {
        BarCodeValue: undefined,
        Location: undefined,
        LocationCode: undefined,
      },
      viewPoints: [{ menuText: "Details", value: 0, type: "details" }],
    };
  },
  computed: {
    detailPopUpConfig() {
      return {
        save: {
          text: "SAVE",
          clickCallback: () => {
            this.detailPopUpSaveCallBack();
          },
          disabled: !this.detailPopUpData.EnableSave,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.detailPopUpBackButtonClick();
          },
        },
        option: {
          title: {
            text: "NONE",
            visible: false,
          },
        },
      };
    },
    headerConfig() {
      return {
        options: {
          multiViewSelect: false,
          addNew: true,
          viewPoints: this.viewPoints,
        },
        data: {
          addNew: {
            icon: "plus",
            type: "normal",
            class: "class-a1",
            cssClass: "class-a2",
            userAcknowledgedInvalidBarcode: true,
            onClick: () => {
              this.onClickAddNew();
            },
          },
        },
      };
      // background-color: #03a9f4 !important;
    },
    dataModelToPass() {
      return this.dataModel;
    },
    getScreenJson() {
      var screenConfig = {
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              localDataList: true,
              items: this.productsList,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "hooray",
            //     title: "No Orders",
            //     message:
            //       "Your work is complete, all orders have been despatched.",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
              rowSelect: false,
            },
            hideNoDataImage: true,
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "Bin",
              alignment: "left",
            },
            {
              screenField: "Variety",
            },
          ],
        },
      };

      return screenConfig;
    },
    getDetailPopupFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "LocationCode",
              label: {
                text: "Location Code",
              },
              editorType: "dxTextBox",
              editorOptions: {
                readOnly: true,
              },
            },
            {
              dataField: "BarCodeValue",
              label: {
                text: "Bar Code",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
                onValueChanged: async (e) => {
                  this.detailsSalesUMPickedQtyValueChange(e);
                },
              },
            },
          ],
        },
      ];
    },
  },
  methods: {
    saveRoamTransaction() {
      this.setIgnoreRouteChangeConfirmation();
      this.$router.push({
        path: "/roam-bin-movement",
      });
    },
    async detailPopUpBackButtonClick() {
      let confirmLeaving = await this.$confirm(
        "Are you sure you want to cancel?",
        "Cancel"
      );

      if (confirmLeaving) {
        this.detailPopUpFormVisible = false;
      }
    },
    detailPopUpSaveCallBack() {
      // console.log('detailPopUpSaveCallBack ', data);
      this.detailPopUpFormVisible = false;
      this.barcodeScanned(this.detailPopUpFormDataModel.BarCodeValue);
    },
    onClickAddNew() {
      this.detailPopUpData.EnableSave = false;
      this.detailPopUpFormVisible = !this.detailPopUpFormVisible;
      // console.log("********************", this.detailPopUpFormVisible);

      // setTimeout(() => {
      //   this.detailPopUpFormVisible = false;
      // }, 500);
    },
    async detailsSalesUMPickedQtyValueChange() {
      this.saveDisabled.detail = false;
      this.saveDisabled.line = true;
      this.detailPopUpData.EnableSave = true;
    },
    getBinLocation() {
      RoamTransactionService.getByCode(
        "BinLocation",
        `Code eq '${this.baseView.id}'`
      )
        .then(async (res) => {
          this.dataModel = res.data.value[0];
          this.dataModel["SaveOption"] = undefined;

          this.$store.dispatch(
            "transactionTemplate/setPrimaryLabel",
            "Location Code " + this.dataModel.Code
          );

          this.$store.dispatch(
            "transactionTemplate/setSecondaryLabel",
            this.dataModel.Location
          );

          this.detailPopUpFormDataModel.LocationCode = this.dataModel.Code;
          this.detailPopUpFormDataModel.Location = this.dataModel.Location;
          this.setLoading = false;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err) console.log("err", err);
          this.setLoading = false;
        });
    },
    detailPopUpDataCallBack(data) {
      this.detailPopUpData = data;
    },
    detailPopUpBack() {
      this.saveDisabled.line = false;
    },
    getPayload() {
      return "getPayload";
    },
    updateTertiaryLabel(labelText) {
      this.$store.dispatch("transactionTemplate/setTertiaryLabel", labelText);
    },
    playBeep(){
      // the audio file needs to be created so that it can be queued and played
      // otherwise if we use a global audio file, it will not play if it is already playing
      let barcodeScannerAudio = new Audio('/barcode-scanner-sound.mp3');
      barcodeScannerAudio.play();
    },
    async barcodeScanned(barcode) {
      if(this.userAcknowledgedInvalidBarcode === false){
        return;
      }
      // barcode = "19254797fglf";
      if (barcode) {
        // eslint-disable-next-line no-console
        console.log("barcode", barcode);
        await RoamBinMovementsService.getByBarCode(barcode)
          .then((res) => {
            this.playBeep();
            this.saveNewBinLocationData(res.data);
          })
          .catch(async (err) => {
            this.detailPopUpFormDataModel.BarCodeValue = undefined;
            if (err){
              this.userAcknowledgedInvalidBarcode = false;
              await this.$alert(
                "Invalid barcode",
                "Error"
              );
              this.userAcknowledgedInvalidBarcode = true;
            }
          });
      }
    },
    async saveNewBinLocationData(data) {
      // BinIsFull: true
      // BinIsQuarantined: false
      // CardNumber: 254797
      // ItemCode: "NP27"
      // ItemShortCode: "fgl"
      // ProdCat1: "NP"
      // ProdCat2: "103"
      // ScannedBarcode: "19254797fglf"
      // SeasonYear: 2019
      await RoamBinMovementsService.saveNew({
        BinCardNo: data.CardNumber,
        SeasonCode: data.SeasonYear,
        LocationID: this.dataModel.Code,
      })
        .then((res) => {
          // eslint-disable-next-line no-console
          console.log("Save Bin res", res);
          this.productsList.unshift({
            Bin: data.CardNumber,
            Variety: data.ProdCat1,
          });
          this.detailPopUpFormDataModel.BarCodeValue = undefined;
          this.saveDisabled.detail = false;
        })
        .catch((err) => {
          this.detailPopUpFormDataModel.BarCodeValue = undefined;
          // eslint-disable-next-line no-console
          console.log("Save Bin err", err);
        });
    },
  },
};
</script>

<style lang="scss"></style>
